import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDrTable, ITarget } from '../../types/interfaces';

import DrAnswer from './DrAnswer';
import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faExternalLinkAlt, faFileInvoice, faPen, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import PDFLink from '../pdf/PDFLink';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';

const DrTable = ({ 
  drsData,
 }: IDrTable) => {
  const [selectedValue, setSelectedValue] = useState('');
  const skipResetRef = React.useRef(false);
  const [modal, setModal] = useState(false);
  const [modalDr, setModalDr] = useState('');
  const [answer, setAnswer] = useState(-1);
  const history = useHistory();

  const alert = useAlert();
  
  const handleSelectChange = data => {
    setSelectedValue(data ? data.value : '');
  }
  
  const handleToggle = () => setModal(!modal);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        hidden: true
      },
      {
        Header: "Vente",
        accessor: "contrat_id",
        Cell: ({ value, row: {original} }) => {
          return <div className="fullFlexCenter">
          <a href={value !== null && value !== undefined ? (`/consultation/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/consultation/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/consultation/${value}` })
            }
            else
              alert.error(E_ERROR.NO_BIEN_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>
          <div className="actionsContainer">
              <PDFLink documentType={"vente"}
                func={async () => getVenteByIdPromise(value || -1)}
                download={false}
                buttonText=""
                iconSize="inherit"
                // customClassNames="btn btn-info"
                customButtonIcon={faFileInvoice}
                allowPrintPreview={true}
                htmlTitle={`Voir la fiche de Vente`}
                customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
          </div>
          </div>
        }
      },
      {
        Header: "Bien",
        accessor: e => e.contrat?.DESIGNATION || "",
        Cell: ({ value, row: {original} }) => {
          return (<a href={original.bien_id !== null && original.bien_id !== undefined ? (`/consultation/bien/${original.bien_id}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(original.bien_id !== null && original.bien_id !== undefined){
              if (e.ctrlKey){
                window.open('/consultation/bien/' + original.bien_id,'_blank');
                return;
              }
              history.push({ pathname: `/consultation/bien/${original.bien_id}` })
            }
            else
              alert.error(E_ERROR.NO_BIEN_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value || original.bien_id}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        }
      },
      {
        Header: "N°",
        accessor: e => e.contrat?.N || "",
        Cell: ({ value }) => value || "-"
      },
      // {
      //   Header: "Type",
      //   accessor: "TYPE_2",
      //   customExportDisplay: `$.bien && $.bien.TYPE ? $.bien.TYPE : "-"`,
      //   // Filter: (e) => SelectColumnFilter({...e, capitalizeFirst: true}),
      //   // filter: 'equals',
      //   Cell: ({ row: {original} }) => original.contrat?.TYPE || "-"
      // },
      {
        Header: "Type",
        accessor: e => e.contrat?.TYPE?.toLowerCase().includes("app") ? "Appartement" : e.contrat?.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (e.contrat?.TYPE || "-"),
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Tranche",
        accessor: e => e.contrat?.TRANCHE || "",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Type Vente",
        accessor: e => e.contrat?.TYPE_VENTE === "UNIQUE" ? "Normale" : e.contrat?.TYPE_VENTE === "ASSOCIATION" ? "Association" : (e.contrat?.TYPE_VENTE || ""),
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      // {
      //   Header: "Immeuble",
      //   accessor: "IMMEUBLE",
      //   Cell: ({ row: {original} }) => (!original.bien || (!original.contrat?.IMMEUBLE && original.contrat?.IMMEUBLE !== "0")) ? "-" : original.contrat?.IMMEUBLE
      // },
      {
        Header: "Prix du M²",
        accessor: "prix_m",
        hidden: true,
        // Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        // filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ row: {original} }) => (original.prix_m !== null && original.prix_m !== undefined && original.prix_m != "") ? (original.prix_m.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Prix du bien",
        accessor: "prix",
        // Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        // filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ row: {original}, columns }) => (original.prix !== null && original.prix !== undefined && original.prix != "") ? (original.prix_m !== null && original.prix_m !== undefined && original.prix_m != "") ? (<div><div style={{display: "inline-block"}}>{((original.prix !== null && original.prix !== undefined && original.prix != "") ? (original.prix.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.id === "prix_m")?.isVisible ? (" (" + ((original.prix_m !== null && original.prix_m !== undefined && original.prix_m != "") ? (original.prix_m.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-") + "/m²)") : "")}</div></div>) : (original.prix.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Remise (du total)",
        accessor: "remise",
        // Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        // filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ row: {original} }) => (original.remise !== null && original.remise !== undefined && original.remise != "") ? (original.remise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Demandée par",
        accessor: "username",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Demandée le",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt) : ""`,
        filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-"
      },
      {
        Header: "Confirmation D.G.",
        accessor: "dgApproved",
        Cell: ({ value, row: {original} })=> value === 1 ? original.dgAt ? <div title={moment(original.dgAt).format('DD/MM/YYYY - HH:mm')}>{moment(original.dgAt).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "Oui" : value === 0 ? "Refusée" : "Pas encore"
      },
      {
        Header: "Confirmation D.C.",
        accessor: "dcApproved",
        Cell: ({ value, row: {original} })=> value === 1 ? original.dcAt ? <div title={moment(original.dcAt).format('DD/MM/YYYY - HH:mm')}>{moment(original.dcAt).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "Oui" : value === 0 ? "Refusée" : "Pas encore"
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                {row.original.approved !== 1 ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => {setAnswer(1); setModalDr(row.original); setModal(true)}}
                  title="Accepter">
                  <FontAwesomeIcon icon={faCheck} />
                </button> : null}
                {row.original.approved !== 1 ? <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {setAnswer(0); setModalDr(row.original); setModal(true)}}
                  title="Refuser">
                  <FontAwesomeIcon icon={faTimes} />
                </button> : null}
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );
  
  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={drsData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <DrAnswer modal={modal} setModal={setModal} handleToggle={handleToggle} modalDr={modalDr} answer={answer} />
    </div>
  );
};

export default connect(null, {})(DrTable);
